var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.state && _vm.query
    ? _c("li", { staticClass: "margin-right-sm" }, [
        _c(
          "button",
          {
            staticClass: "icon-facet-pill tag flat rounded",
            staticStyle: {
              "--tag-background": "var(--white)",
              "--button-margin-bottom": "0",
              "--button-hover-background": "var(--white)",
              "--button-active-background": "var(--white)",
              "--link-decoration-style": "none",
              "--link-decoration-line": "none",
              "--link-hover-decoration-style": "none",
              "--link-hover-decoration-line": "none",
              "--tag-padding": "var(--spacing-sm) var(--spacing-md)",
            },
            on: {
              click: function ($event) {
                $event.preventDefault()
                return _vm.clearSearchQuery()
              },
            },
          },
          [
            _vm._v("\n    “" + _vm._s(_vm.query) + "”\n    "),
            _c("font-awesome-icon", {
              staticClass: "icon-facet-pill-affordance margin-left-4xs",
              attrs: { icon: _vm.$v6.solid.faXmark, "fixed-width": "" },
            }),
          ],
          1
        ),
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }